// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"597":"8ab4bc4f","690":"f412f355"}[chunkId] + ".chunk.css";
};